module.exports = __webpack_public_path__ + "static/img/logo@2x.5e49505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo@2x.png
// module id = XZF3
// module chunks = 1